export const email = "martin.turon@zmservis-moravia.cz";
